import * as React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker'
import { DateOrTimeView } from '@mui/x-date-pickers/models'
import { addDays } from 'date-fns'
import { theme } from './theme'
import { EventScheduleIcon as DateTimeIcon } from '../icons'
import { DesktopDateTimePicker } from '@mui/x-date-pickers'

const now = new Date()

export interface DateTimePickerProps {
  value: Date | null | undefined
  onChange: (date: Date, context?: any) => void
  format?: string
  placeholder?: string
  ampm?: boolean
  disabled?: boolean
  minDate?: Date
  maxDate?: Date
  minDateTime?: Date
  maxDateTime?: Date
  views?: DateOrTimeView[]
  onError?: (errorType: string) => void
  slotProps?: any
  slots?: object
}

const dateTimePicker =
  (keyboard = false): React.FC<DateTimePickerProps> =>
  ({
    value,
    onChange,
    format = 'yyyy-MM-dd HH:mm',
    placeholder = 'DateTime',
    ampm = false,
    disabled = false,
    minDate = addDays(now, -100 * 365),
    maxDate = addDays(now, 100 * 365),
    minDateTime,
    maxDateTime,
    views = ['year', 'month', 'day', 'hours', 'minutes'],
    onError,
    slots = {},
    slotProps = {},
  }) => {
    const Component = keyboard ? DesktopDateTimePicker : MobileDateTimePicker
    const props = {
      value,
      format,
      placeholder,
      ampm,
      disabled,
      minDate,
      maxDate,
      minDateTime,
      maxDateTime,
      views,
      onChange,
      onError,
      slots: {
        ...slots,
        openPickerIcon: DateTimeIcon,
      },
      slotProps: {
        ...slotProps,
        textField: {
          ...slotProps.textField,
          InputLabelProps: { shrink: false },
          inputProps: { placeholder },
          size: 'small',
        },
      },
      dayOfWeekFormatter: (day: string) => day,
    }

    return (
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Component {...props} />
        </LocalizationProvider>
      </ThemeProvider>
    )
  }

export const DateTimePicker = dateTimePicker()
export const KeyboardDateTimePicker = dateTimePicker(true)
